import React, { memo, useState, useEffect } from "react";
import { Card, CardBody, Row, Col, Button, ButtonToolbar, Alert, Spinner } from "reactstrap";
import { MdRefresh } from "react-icons/md";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { MdArrowBack } from "react-icons/md";
import { Link } from "react-router-dom";
import validateRoles from "./validateRoles";
import RolesSelect from "../../../Roles/RolesSelect";
import { toggleUser } from "../../actions/user.actions";
import AccessControl from "../../../../shared/components/AccessControl";
import { permissionsConstants } from "../../../../constants/permission.constants";

const UserForm = memo((props) => {
    const { handleSubmit, reset, pristine, submitting, userId, dispatch, toggleuser, user, postuser, change, fetchData } = props;
    const [roleNotChange, setRoleNotChange] = useState(true);

    useEffect(() => {
        return () => {
            setRoleNotChange(true);
        };
    }, []);

    const resetForm = () => {
        reset();
    };
    const fetchUserRoles = () => {
        fetchData();
    };

    useEffect(() => {
        if (!postuser.loading) {
            
            setRoleNotChange(true);
        }
    }, [postuser.loading]);

    const onChangeUserRole = (e) => {
        if (e && e.name && user.response && user.response.roleName) {
            if (e.name === user.response.roleName) {
                setRoleNotChange(true);
            } else {
                setRoleNotChange(false);
            }
        }
    };
    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="card__title">
                        <h5 className="bold-text">
                            <Link to="/users" id="link-all-users">
                                <MdArrowBack size={20} /> Back to users
                            </Link>
                        </h5>
                    </div>
                    {userId && user && user.loading ? (
                        <div className="text-center">
                            <Spinner color="success" className="my-4" style={{ width: "6rem", height: "6rem" }} />
                            <h4 className="text-secondary">Fetching roles for user with username ({userId})</h4>
                        </div>
                    ) : (
                        <div>
                            {user && user.error ? (
                                <section>
                                    <h4 className="text-danger">{`Something went wrong. ${user.error && user.error.description ? user.error.description : "Could not fetch user with username"} ${userId}`}</h4>
                                    <Alert color="danger">
                                        Could not get User Roles Details
                                        <MdRefresh onClick={fetchUserRoles} className="float-right pointer" size={20} />
                                    </Alert>
                                </section>
                            ) : (
                                <div>
                                    <dl className="row">
                                        <dt className="col-sm-2">Username</dt>
                                        <dd className="col-sm-10">
                                            <p>{user.response && user.response.username}</p>
                                        </dd>
                                        <dt className="col-sm-2">Current Role</dt>
                                        <dd className="col-sm-10">
                                            <p>{user.response && user.response.roleName}</p>
                                        </dd>
                                        <dt className="col-sm-2">Current Domain</dt>
                                        <dd className="col-sm-10">
                                            <p>{user.response && user.response.domainCode}</p>
                                        </dd>
                                        <dt className="col-sm-2">Active</dt>
                                        <dd className="col-sm-10">
                                            <p>{user.response && user.response.enabled ? <span className="text-success">Active</span> : <span className="text-danger">Inactive</span>}</p>
                                        </dd>
                                    </dl>
                                    {user.response && user.response.enabled ? (
                                        <form className="form" onSubmit={handleSubmit}>
                                            <Row>
                                                <Col lg="4">
                                                    <AccessControl allowedPermissions={[]} renderNoAccess={() => <Alert color="danger">You do not have access to change a user's role</Alert>}>
                                                        <RolesSelect
                                                            required
                                                            domainCode={user.response && user.response.domainCode}
                                                            label="Change user's role"
                                                            change={change}
                                                            isUserRolesForm={true}
                                                            userRoleName={user.response && user.response.roleName}
                                                            userRoleId={user.response && user.response.roleId}
                                                            onChange={onChangeUserRole}
                                                        />
                                                    </AccessControl>
                                                </Col>
                                            </Row>

                                            <ButtonToolbar className="form__button-toolbar">
                                                <Button type="button" id="btn-reset" onClick={resetForm} disabled={pristine || submitting}>
                                                    Cancel
                                                </Button>
                                                <Button id="btn-submit" color="primary" type="submit" disabled={pristine || roleNotChange || submitting}>
                                                    {postuser && postuser.loading ? (
                                                        <span>
                                                            <Spinner size="sm" color="default" />{" "}
                                                        </span>
                                                    ) : null}
                                                    Submit
                                                </Button>
                                            </ButtonToolbar>
                                        </form>
                                    ) : (
                                        <Row>
                                            <Col lg="4">
                                                <Alert color="danger">
                                                    <Row>
                                                        <Col lg="7">
                                                            <p className="font-weight-bold">This user is currently disabled</p>
                                                            <small>To change role, please re-enabled this user</small>
                                                        </Col>
                                                        <Col lg="5">
                                                            {user && user.response && (
                                                                <Button size="sm" id="btn-enable-user" className="mb-0" color="danger" onClick={() => dispatch(toggleUser(user.response.username, user.response.enabled, "refreshMapping"))}>
                                                                    {toggleuser.loading ? <Spinner size="sm" /> : <span>Enable</span>}
                                                                </Button>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Alert>
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </CardBody>
            </Card>
        </Col>
    );
});

UserForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
};

export default reduxForm({
    form: "userrole_form",
    validate: validateRoles,
    enableReinitialize: true,
})(
    connect((state) => ({
        postuser: state.editRole,
        toggleuser: state.toggleuser,
    }))(UserForm)
);
